<template>
	<div class="file-icon" :style="{ width: size + 'px', height: size + 'px' }">
		<!-- PDF文件图标 -->
		<svg v-if="fileType === 'pdf'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#E53E3E"/>
			<path d="M12 32h24M12 36h16" stroke="white" stroke-width="2" stroke-linecap="round"/>
			<text x="24" y="22" text-anchor="middle" fill="white" font-size="10" font-weight="bold">PDF</text>
		</svg>

		<!-- Word文档图标 -->
		<svg v-else-if="fileType === 'word'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#2B6CB0"/>
			<path d="M12 32h24M12 36h20M12 28h18" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
			<text x="24" y="20" text-anchor="middle" fill="white" font-size="8" font-weight="bold">DOC</text>
		</svg>

		<!-- Excel表格图标 -->
		<svg v-else-if="fileType === 'excel'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#38A169"/>
			<path d="M14 16h20M14 20h20M14 24h20M14 28h20M14 32h20" stroke="white" stroke-width="1.5"/>
			<path d="M20 14v20M28 14v20" stroke="white" stroke-width="1.5"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="7" font-weight="bold">XLS</text>
		</svg>

		<!-- PowerPoint图标 -->
		<svg v-else-if="fileType === 'powerpoint'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#D69E2E"/>
			<rect x="14" y="16" width="20" height="12" rx="2" stroke="white" stroke-width="1.5" fill="none"/>
			<circle cx="18" cy="22" r="1" fill="white"/>
			<text x="24" y="36" text-anchor="middle" fill="white" font-size="7" font-weight="bold">PPT</text>
		</svg>

		<!-- 图片文件图标 -->
		<svg v-else-if="fileType === 'image'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#805AD5"/>
			<rect x="12" y="14" width="24" height="18" rx="2" stroke="white" stroke-width="1.5" fill="none"/>
			<circle cx="18" cy="20" r="2" stroke="white" stroke-width="1.5" fill="none"/>
			<path d="M12 28l6-6 4 4 8-8 6 6v4" stroke="white" stroke-width="1.5" fill="none"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="7" font-weight="bold">IMG</text>
		</svg>

		<!-- 视频文件图标 -->
		<svg v-else-if="fileType === 'video'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#E53E3E"/>
			<rect x="10" y="16" width="28" height="16" rx="2" stroke="white" stroke-width="1.5" fill="none"/>
			<polygon points="20,20 20,28 26,24" fill="white"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="7" font-weight="bold">MP4</text>
		</svg>

		<!-- 音频文件图标 -->
		<svg v-else-if="fileType === 'audio'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#38A169"/>
			<path d="M20 14v20M24 10v28M28 16v16M32 18v12M16 18v12" stroke="white" stroke-width="2" stroke-linecap="round"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="7" font-weight="bold">MP3</text>
		</svg>

		<!-- 压缩文件图标 -->
		<svg v-else-if="fileType === 'archive'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#744210"/>
			<rect x="14" y="12" width="20" height="24" rx="2" stroke="white" stroke-width="1.5" fill="none"/>
			<path d="M18 16h12M18 20h12M18 24h12M18 28h12" stroke="white" stroke-width="1"/>
			<text x="24" y="42" text-anchor="middle" fill="white" font-size="7" font-weight="bold">ZIP</text>
		</svg>

		<!-- 代码文件图标 -->
		<svg v-else-if="fileType === 'code'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#319795"/>
			<path d="M16 18l-4 6 4 6M32 18l4 6-4 6M22 14l-4 20" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="6" font-weight="bold">CODE</text>
		</svg>

		<!-- 文本文件图标 -->
		<svg v-else-if="fileType === 'text'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#4A5568"/>
			<path d="M14 16h20M14 20h22M14 24h18M14 28h20M14 32h16" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="7" font-weight="bold">TXT</text>
		</svg>

		<!-- 可执行文件图标 -->
		<svg v-else-if="fileType === 'executable'" viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#2D3748"/>
			<rect x="16" y="14" width="16" height="16" rx="2" stroke="white" stroke-width="1.5" fill="none"/>
			<rect x="20" y="18" width="8" height="8" rx="1" fill="white"/>
			<text x="24" y="38" text-anchor="middle" fill="white" font-size="7" font-weight="bold">EXE</text>
		</svg>

		<!-- 默认文件图标 -->
		<svg v-else viewBox="0 0 48 48" width="100%" height="100%">
			<rect width="48" height="48" rx="4" fill="#718096"/>
			<path d="M14 10h14l6 6v26H14V10z" stroke="white" stroke-width="1.5" fill="none"/>
			<path d="M28 10v6h6" stroke="white" stroke-width="1.5" fill="none"/>
			<path d="M18 22h12M18 26h12M18 30h8" stroke="white" stroke-width="1" stroke-linecap="round"/>
			<text x="24" y="40" text-anchor="middle" fill="white" font-size="6" font-weight="bold">FILE</text>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'FileIcon',
	props: {
		fileName: {
			type: String,
			required: true
		},
		size: {
			type: Number,
			default: 44
		}
	},
	computed: {
		fileType() {
			if (!this.fileName) return 'default';
			
			// 获取文件扩展名
			const extension = this.fileName.toLowerCase().split('.').pop();
			
			// 根据扩展名确定文件类型
			switch (extension) {
				// PDF文件
				case 'pdf':
					return 'pdf';
				
				// Word文档
				case 'doc':
				case 'docx':
					return 'word';
				
				// Excel表格
				case 'xls':
				case 'xlsx':
				case 'csv':
					return 'excel';
				
				// PowerPoint
				case 'ppt':
				case 'pptx':
					return 'powerpoint';
				
				// 图片文件
				case 'jpg':
				case 'jpeg':
				case 'png':
				case 'gif':
				case 'bmp':
				case 'webp':
				case 'svg':
				case 'ico':
					return 'image';
				
				// 视频文件
				case 'mp4':
				case 'avi':
				case 'mov':
				case 'wmv':
				case 'flv':
				case 'mkv':
				case 'webm':
				case '3gp':
					return 'video';
				
				// 音频文件
				case 'mp3':
				case 'wav':
				case 'flac':
				case 'aac':
				case 'ogg':
				case 'wma':
				case 'm4a':
					return 'audio';
				
				// 压缩文件
				case 'zip':
				case 'rar':
				case '7z':
				case 'tar':
				case 'gz':
				case 'bz2':
				case 'xz':
					return 'archive';
				
				// 代码文件
				case 'js':
				case 'ts':
				case 'html':
				case 'htm':
				case 'css':
				case 'scss':
				case 'sass':
				case 'less':
				case 'vue':
				case 'jsx':
				case 'tsx':
				case 'json':
				case 'xml':
				case 'yml':
				case 'yaml':
				case 'py':
				case 'java':
				case 'cpp':
				case 'c':
				case 'cs':
				case 'go':
				case 'php':
				case 'rb':
				case 'swift':
				case 'kt':
				case 'sql':
				case 'sh':
				case 'bat':
					return 'code';
				
				// 文本文件
				case 'txt':
				case 'md':
				case 'markdown':
				case 'log':
				case 'cfg':
				case 'conf':
				case 'ini':
					return 'text';
				
				// 可执行文件
				case 'exe':
				case 'msi':
				case 'dmg':
				case 'pkg':
				case 'deb':
				case 'rpm':
				case 'appimage':
					return 'executable';
				
				// 默认
				default:
					return 'default';
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.file-icon {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
</style>